import { Typography } from "@mui/material";
import DocumentDialogIcon from "@entrilia/shared/icons/DocumentDialogIcon";

const EmptyFileDetailsPanel = () => {
  return (
    <>
      <DocumentDialogIcon color="secondary" sx={{ width: 80, height: 80 }} />
      <Typography color="textSecondary">Select a file to see its details</Typography>
    </>
  );
};

export default EmptyFileDetailsPanel;
